(function () {
  var PRICE_FOR_QTY = {
    fr: 'pour {{ count }} u.',
    en: 'for {{ count }} units'
  };

  function parseStep(input) {
    var step = parseInt(String(input.getAttribute('step') || '1'), 10);
    return isNaN(step) || step < 1 ? 1 : step;
  }

  function parseMin(input) {
    var min = parseInt(String(input.getAttribute('min') || '1'), 10);
    return isNaN(min) || min < 1 ? 1 : min;
  }

  function snapQty(input) {
    var min = parseMin(input);
    var step = parseStep(input);
    var v = parseInt(String(input.value), 10);

    if (isNaN(v) || v < min) {
      v = min;
    } else {
      var offset = v - min;
      var steps = Math.round(offset / step);
      v = min + steps * step;
      if (v < min) v = min;
    }

    input.value = String(v);
    return v;
  }

  function formatMoneyCents(cents) {
    var c = parseInt(String(cents || 0), 10);
    if (isNaN(c)) c = 0;
    var amount = c / 100;
    var out;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.Shopify.money_format || '{{amount}} dh').replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{amount}}');
      out = window.Shopify.formatMoney(c, fmt);
    } else {
      out = amount.toFixed(2) + ' dh';
    }
    if (c % 100 === 0) {
      out = String(out).replace(/([,.])00(?!\d)/g, '');
    }
    return out;
  }

  function priceLabel(qty) {
    var lang = (document.documentElement.lang || 'fr').toLowerCase().slice(0, 2);
    var tpl = PRICE_FOR_QTY[lang] || PRICE_FOR_QTY.fr;
    return tpl.replace('{{ count }}', String(qty));
  }

  function updateCardPrice(input) {
    var card =
      input.closest('.lande-collection-card') ||
      input.closest('.lande-pdp-card') ||
      input.closest('article') ||
      input.closest('form');
    if (!card) return;

    var priceWrap = card.querySelector('[data-mp-card-price]');
    if (!priceWrap) return;

    var qty = snapQty(input);
    var unit = parseInt(String(priceWrap.getAttribute('data-unit-price') || '0'), 10);
    var unitSale = parseInt(String(priceWrap.getAttribute('data-unit-sale') || unit), 10);
    if (isNaN(unit) || unit < 0) unit = 0;
    if (isNaN(unitSale) || unitSale < 0) unitSale = unit;

    var mode = priceWrap.getAttribute('data-price-mode') || 'standard';
    var compareEl = priceWrap.querySelector('[data-mp-price-compare]');
    var mainEl = priceWrap.querySelector('[data-mp-price-main]');
    var labelEl = priceWrap.querySelector('[data-mp-price-qty-label]');

    if (mode === 'first_order') {
      if (compareEl) compareEl.textContent = formatMoneyCents(unit * qty);
      if (mainEl) mainEl.textContent = formatMoneyCents(unitSale * qty);
    } else if (mainEl) {
      mainEl.textContent = formatMoneyCents(unit * qty);
    }

    if (labelEl) labelEl.textContent = priceLabel(qty);
    priceWrap.setAttribute('data-qty', String(qty));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-collection-qty-btn');
    if (!btn) return;

    var wrap = btn.closest('.js-collection-qty');
    if (!wrap) return;

    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;

    var min = parseMin(input);
    var step = parseStep(input);
    var v = parseInt(String(input.value), 10);

    if (isNaN(v) || v < min) v = min;

    if (btn.getAttribute('data-dir') === 'minus') {
      v = Math.max(min, v - step);
    } else {
      v = v + step;
    }

    input.value = String(v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.js-collection-qty input[type="number"]')) return;
    updateCardPrice(e.target);
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;

      form.querySelectorAll('.js-collection-qty input[type="number"]').forEach(function (input) {
        snapQty(input);
      });
    },
    true
  );
})();
